<template>
  <div class="position-relative h-100 mh-100 overflow-hidden">
    <job-template-form
      v-if="!fetchingOutputGroupOptions && !fetchingJobTemplate"
      edit
      :submit-loading="editingJobTemplate"
      @submit="editJobTemplate"
    />
    <loading-page v-else />
  </div>
</template>

<script>
import JobTemplateForm from './JobTemplateForm.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'EditJobtemplate',
  components: { JobTemplateForm },

  data() {
    return {}
  },
  computed: {
    fetchingJobTemplate() {
      return this.$store.state.jobTemplates.fetchingJobTemplate
    },
    fetchingOutputGroupOptions() {
      return this.$store.state.jobTemplates.fetchingOutputGroupOptions
    },
    editingJobTemplate() {
      return this.$store.state.jobTemplates.editingJobTemplate
    },
    creatingOutputPreset() {
      return this.$store.state.jobTemplates.creatingOutputPreset
    },
  },
  created() {
    if (
      !this.$route.params.backFromOutputPresets
      || !this.creatingOutputPreset
    ) {
      this.init()
    }
  },

  methods: {
    init() {
      this.fetchJobTemplate()
      this.fetchOutputGroupOptions()
      this.$store.commit('jobTemplates/SET_OUTPUT_TABS', [])
    },
    fetchJobTemplate() {
      this.$store
        .dispatch('jobTemplates/fetchJobTemplateById', this.$route.params.id)
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    fetchOutputGroupOptions() {
      this.$store.dispatch('jobTemplates/fetchOutputGroupOptions')
    },
    editJobTemplate(obj) {
      this.$store
        .dispatch('jobTemplates/editJobTemplate', obj)
        .then(() => {
          this.$router.push({
            name: 'job-templates',
            params: {
              projectId: this.$route.params.projectId,
              toast: {
                title: 'Success',
                variant: 'success',
                message: 'Job template updated successfully!',
              },
            },
          })
        })
        .catch(err => {
          const errMessage = err.response?.data?.Message || 'An error occurred'
          this.errorToast(errMessage)
        })
    },
  },
}
</script>
